var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-sm text-theme-blue"},[_c('SaLink',{attrs:{"to":_vm.learnMoreUrl},on:{"click":_vm.closeModals}},[_vm._v(_vm._s(_vm.$t('Learn more about User Accounts.')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }